import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';

Vue.use(Vuex);

const state = {
  drawer: true,
  listaEmpresas: [],
  listaAlumnosUNI: [],
  listaAlumnosUNIbackup: [],
  adminData: null,
  noChangeEdit: true,
  selectedAlumnoInfo: null,
  selectedAlumnoEdit: {
    correoAlternativo: '',
    correoUNI: ''
  },
  selectedAdministradorEdit: {
    adminType: '',
    usuario: '',
    password: '',
    usuarioActivo: false
  },
  estadisticaNuevosIngresos: [],
  listaAdministradores: [],
  editAlumnoDialog: false,
  editAdministradorDialog: false,
  showAlumnoInfoDialog: false,
  createAdministradorDialog: false,
  createNewDialog: false,
  listaNews: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
